import Vue from 'vue';
import VueI18n from 'vue-i18n';
import locales_vi from './locales/vi';
import locales_en from './locales/en';

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'vi', // Ngôn ngữ mặc định
  fallbackLocale: 'vi',
  messages: {
    vi: locales_vi,
    en: locales_en
  }
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js